<ngx-mat-timepicker [(ngModel)]="result" (ngModelChange)="onResultChange($event)"></ngx-mat-timepicker>
